import React from 'react';

import {Button, Icon} from '@albert-io/atomic';

interface Props {
  onClick: () => void;
}

/** Opens the choose-diagnostic dialog. Callers render it only while the flag is on. */
export const CreateAutomatedSkillPathsButton = ({onClick}: Props) => (
  <Button
    color='primary'
    roundness='pill'
    size='s'
    className='gap-x0-half'
    onClick={onClick}
    data-testid='create-automated-skill-paths-button'
  >
    <Icon icon='sparkles' />
    Create Automated Skill Paths
  </Button>
);
